import React from "react"

export default function SeriesLineLayer({ data, x, y, colour, strokeWidth = 3 }) {
  if (typeof colour === "function") {
    const segs = []
    let lastX, lastY
    for (let i = 0; i < data.length; ++i) {
      const obs = data[i]
      const px = x(obs),
        py = y(obs)

      if (i > 0) {
        segs.push(
          <line
            key={i}
            x1={lastX}
            y1={lastY}
            x2={px}
            y2={py}
            stroke={colour(obs)}
            strokeWidth={strokeWidth}
          />,
        )
      }

      lastX = px
      lastY = py
    }
    return <g>{segs}</g>
  } else {
    const pathData = data
      .map((obs, index) => `${index === 0 ? "M" : "L"}${x(obs)},${Math.min(5000, Math.max(-5000, y(obs)))}`)
      .join(" ")

    return <path d={pathData} fill="none" stroke={colour} strokeWidth={strokeWidth} />
  }
}
